class PropsValidator {
  /**
   * @param {Array} values
   * @param {String} prop
   * @returns Boolean
   * @example
   * validation: color => PropsValidator.validate(COLORS_LIST, color)
   */
  static validate (values, prop) {
    if (!Array.isArray(values)) {
      throw new Error('Invalid type values provided')
    }
    return values.includes(prop)
  }
}

export default PropsValidator
